// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `* {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
}

html {
  overscroll-behavior: none;
}

body {
  font-family: 'Segoe UI', -apple-system, BlinkMacSystemFont, 'Roboto', sans-serif;
  background: #f0f2f5;
  color: #1a1a2e;
  font-size: 14px;
  line-height: 1.5;
  overscroll-behavior: none;
}

/* Typography System - Uniform Font Sizes */
h1 {
  font-size: 1.85rem;
  font-weight: 600;
  line-height: 1.2;
  color: #1a1a2e;
}

h2 {
  font-size: 1.25rem;
  font-weight: 600;
  line-height: 1.3;
  color: #2d3748;
  margin-bottom: 12px;
}

h3 {
  font-size: 1.1rem;
  font-weight: 600;
  line-height: 1.3;
  color: #2d3748;
}

h4 {
  font-size: 0.95rem;
  font-weight: 600;
  line-height: 1.4;
  color: #4a5568;
}

p,
label,
span,
div {
  font-size: 14px;
  line-height: 1.5;
}

/* Form Controls - Uniform Styling */
input[type="text"],
input[type="email"],
input[type="password"],
input[type="number"],
input[type="date"],
input[type="time"],
select,
textarea {
  font-family: inherit;
  font-size: 14px !important;
  line-height: 1.5;
  color: #2d3748;
  padding: 8px 12px;
  border: 1px solid #cbd5e0;
  border-radius: 6px;
  transition: all 0.2s;
}

input[type="text"]:focus,
input[type="email"]:focus,
input[type="password"]:focus,
input[type="number"]:focus,
input[type="date"]:focus,
input[type="time"]:focus,
select:focus,
textarea:focus {
  outline: none;
  border-color: #3182ce;
  box-shadow: 0 0 0 3px rgba(49, 130, 206, 0.1);
}

/* Labels */
label {
  font-size: 13px;
  font-weight: 500;
  color: #4a5568;
  display: block;
  margin-bottom: 6px;
}

/* Buttons - Uniform Font Size */
button {
  font-family: inherit;
  font-size: 14px;
  font-weight: 600;
}

/* Loading Screen */
.loading-screen {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  min-height: 100vh;
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  color: white;
}

.spinner {
  width: 50px;
  height: 50px;
  border: 4px solid rgba(255, 255, 255, 0.3);
  border-top-color: white;
  border-radius: 50%;
  animation: spin 1s linear infinite;
  margin-bottom: 15px;
}

@keyframes spin {
  to {
    transform: rotate(360deg);
  }
}

/* Global Standard Layout Elements */
.standard-header {
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  margin-bottom: 24px;
}

.standard-header-info h1 {
  font-size: 1.85rem;
  color: #1a1a2e;
  margin: 0;
  display: flex;
  align-items: center;
  gap: 12px;
}

.standard-header-info p {
  color: #718096;
  margin: 5px 0 0;
  font-size: 0.95rem;
}

.standard-header-actions {
  display: flex;
  gap: 12px;
  align-items: center;
}

/* Standard Buttons and Controls */
.btn-primary {
  background: #3182ce;
  color: white;
  border: none;
  padding: 10px 20px;
  border-radius: 8px;
  font-weight: 600;
  font-size: 14px;
  cursor: pointer;
  transition: all 0.2s;
  display: flex;
  align-items: center;
  gap: 8px;
}

.btn-primary:hover {
  background: #2b6cb0;
  transform: translateY(-1px);
  box-shadow: 0 4px 12px rgba(49, 130, 206, 0.25);
}

.btn-secondary {
  background: white;
  color: #4a5568;
  border: 1px solid #e2e8f0;
  padding: 10px 20px;
  border-radius: 8px;
  font-weight: 600;
  font-size: 14px;
  cursor: pointer;
  transition: all 0.2s;
  display: flex;
  align-items: center;
  gap: 8px;
}

.btn-secondary:hover {
  background: #f7fafc;
  border-color: #cbd5e0;
}

/* Standard Search Box */
.search-container {
  background: white;
  border: 1px solid #e2e8f0;
  border-radius: 8px;
  padding: 9px 16px;
  display: flex;
  align-items: center;
  gap: 10px;
  width: 100%;
  max-width: 450px;
  box-shadow: 0 1px 2px rgba(0, 0, 0, 0.05);
  transition: all 0.2s;
  margin-bottom: 20px;
}

.search-container:focus-within {
  border-color: #3182ce;
  box-shadow: 0 0 0 3px rgba(49, 130, 206, 0.1);
}

.search-container input {
  border: none;
  outline: none;
  width: 100%;
  font-size: 0.92rem;
  color: #2d3748;
}

.search-icon {
  color: #a0aec0;
  font-size: 1.1rem;
}

/* Standard Table — estilo uniforme para toda a plataforma */
.standard-table {
  width: 100%;
  border-collapse: collapse;
  font-size: 13px;
}

.standard-table th {
  background: #f8fafc;
  padding: 10px 14px;
  text-align: left;
  font-weight: 600;
  color: #64748b;
  font-size: 11px;
  text-transform: uppercase;
  letter-spacing: 0.05em;
  border-bottom: 2px solid #edf2f7;
  white-space: nowrap;
}

.standard-table td {
  padding: 9px 14px;
  border-bottom: 1px solid #f3f4f6;
  color: #2d3748;
  font-size: 13px;
  vertical-align: middle;
}

.standard-table tr:last-child td {
  border-bottom: none;
}

.standard-table tr:hover td {
  background: #f8fafc;
}

/* Scrollbar styling */
::-webkit-scrollbar {
  width: 8px;
  height: 8px;
}

::-webkit-scrollbar-track {
  background: #f1f1f1;
}

::-webkit-scrollbar-thumb {
  background: #c1c1c1;
  border-radius: 4px;
}

::-webkit-scrollbar-thumb:hover {
  background: #a1a1a1;
}

/* ---- Shared Sub-navigation (pill tabs) ---- */
.shared-subnav {
  display: flex;
  gap: 4px;
  background: #e2e8f0;
  border-radius: 8px;
  padding: 3px;
  margin-bottom: 14px;
  width: fit-content;
}

.shared-subnav-btn {
  padding: 8px 20px;
  border: none;
  border-radius: 6px;
  font-size: 13px;
  font-weight: 600;
  cursor: pointer;
  color: #64748b;
  background: transparent;
  transition: all 0.15s;
  white-space: nowrap;
}

.shared-subnav-btn:hover { color: #1e293b; background: rgba(255,255,255,0.6); }
.shared-subnav-btn.active { background: #fff; color: #3182ce; box-shadow: 0 1px 4px rgba(0,0,0,0.1); }

/* ---- Shared Search Input ---- */
.shared-search {
  margin-bottom: 20px;
}

.shared-search input {
  width: 100%;
  max-width: 450px;
  padding: 10px 14px;
  border: 1px solid #e2e8f0;
  border-radius: 8px;
  font-size: 0.95rem;
  box-sizing: border-box;
  background: white;
}

.shared-search input:focus {
  outline: none;
  border-color: #3182ce;
  box-shadow: 0 0 0 2px rgba(49, 130, 206, 0.15);
}

/* ====================================================================
   PAGE THEMES — aplicados via data-page-theme no <body>
   "default" não tem regras = padrão intocado
   ==================================================================== */

/* ---------- LIGHT — fundo branco mais limpo ---------- */
body[data-page-theme="light"] {
  background: #ffffff;
}
body[data-page-theme="light"] .page-content,
body[data-page-theme="light"] .app-layout {
  background: #ffffff;
}
body[data-page-theme="light"] .main-content {
  background: #ffffff;
}
/* cards / tabelas */
body[data-page-theme="light"] .card,
body[data-page-theme="light"] .table-card,
body[data-page-theme="light"] .obras-grid > *,
body[data-page-theme="light"] .standard-table th {
  background: #f8fafc;
}
body[data-page-theme="light"] .top-bar {
  background: #ffffff;
  border-bottom-color: #e2e8f0;
}

/* ---------- DARK — fundo escuro nas páginas ---------- */
body[data-page-theme="dark"] {
  background: #0f172a;
  color: #e2e8f0;
}
body[data-page-theme="dark"] .page-content,
body[data-page-theme="dark"] .app-layout,
body[data-page-theme="dark"] .main-content {
  background: #0f172a;
}
body[data-page-theme="dark"] .top-bar {
  background: #1e293b;
  border-bottom-color: rgba(255,255,255,0.08);
  color: #e2e8f0;
}
body[data-page-theme="dark"] .top-bar-title h1,
body[data-page-theme="dark"] .top-bar-title p,
body[data-page-theme="dark"] h1,
body[data-page-theme="dark"] h2,
body[data-page-theme="dark"] h3,
body[data-page-theme="dark"] h4 {
  color: #e2e8f0;
}
body[data-page-theme="dark"] .card,
body[data-page-theme="dark"] .table-card,
body[data-page-theme="dark"] .obras-card,
body[data-page-theme="dark"] .obra-card,
body[data-page-theme="dark"] [class*="-card"],
body[data-page-theme="dark"] [class*="-table"],
body[data-page-theme="dark"] [class*="-panel"],
body[data-page-theme="dark"] [class*="-box"],
body[data-page-theme="dark"] [class*="-container"]:not(.shared-search):not(.search-container) {
  background: #1e293b;
  border-color: rgba(255,255,255,0.08);
  color: #e2e8f0;
}
body[data-page-theme="dark"] .standard-table th {
  background: #0f172a;
  color: #94a3b8;
  border-bottom-color: rgba(255,255,255,0.08);
}
body[data-page-theme="dark"] .standard-table td,
body[data-page-theme="dark"] table td,
body[data-page-theme="dark"] table th {
  border-color: rgba(255,255,255,0.06);
  color: #e2e8f0;
}
body[data-page-theme="dark"] table tr:hover td {
  background: rgba(255,255,255,0.04);
}
body[data-page-theme="dark"] input,
body[data-page-theme="dark"] select,
body[data-page-theme="dark"] textarea {
  background: #0f172a;
  border-color: rgba(255,255,255,0.12);
  color: #e2e8f0;
}
body[data-page-theme="dark"] .shared-search input,
body[data-page-theme="dark"] .search-container input {
  background: #1e293b;
  border-color: rgba(255,255,255,0.12);
  color: #e2e8f0;
}
body[data-page-theme="dark"] .shared-subnav {
  background: #1e293b;
}
body[data-page-theme="dark"] .shared-subnav-btn {
  color: #94a3b8;
}
body[data-page-theme="dark"] .shared-subnav-btn.active {
  background: #0f172a;
  color: #60a5fa;
}
body[data-page-theme="dark"] .btn-secondary {
  background: #1e293b;
  border-color: rgba(255,255,255,0.12);
  color: #e2e8f0;
}
body[data-page-theme="dark"] .btn-secondary:hover {
  background: #334155;
}

/* ---------- SIMPLE — tipografia leve, flat, monocromático ---------- */
body[data-page-theme="simple"] {
  background: #f5f5f5;
  font-family: 'Inter', 'Segoe UI', sans-serif;
  font-weight: 400;
  color: #333;
  font-size: 13px;
}

/* layout */
body[data-page-theme="simple"] .page-content,
body[data-page-theme="simple"] .app-layout,
body[data-page-theme="simple"] .main-content {
  background: #f5f5f5;
}

/* top bar */
body[data-page-theme="simple"] .top-bar {
  background: #fff;
  border-bottom: 1px solid #e0e0e0;
  box-shadow: none;
  padding: 12px 24px;
}
body[data-page-theme="simple"] .top-bar-title h1 {
  font-size: 1.1rem;
  font-weight: 500;
  color: #222;
  letter-spacing: -0.01em;
}
body[data-page-theme="simple"] .top-bar-title p {
  font-size: 0.8rem;
  color: #888;
}

/* tipografia geral */
body[data-page-theme="simple"] h1 {
  font-size: 1.3rem;
  font-weight: 500;
  color: #222;
  letter-spacing: -0.02em;
}
body[data-page-theme="simple"] h2 {
  font-size: 1rem;
  font-weight: 500;
  color: #333;
  letter-spacing: -0.01em;
}
body[data-page-theme="simple"] h3 {
  font-size: 0.9rem;
  font-weight: 500;
  color: #444;
}
body[data-page-theme="simple"] h4 {
  font-size: 0.82rem;
  font-weight: 500;
  color: #555;
}

/* remover todas as sombras e transforms */
body[data-page-theme="simple"] * {
  box-shadow: none !important;
  text-shadow: none !important;
}
body[data-page-theme="simple"] *:hover {
  transform: none !important;
}

/* cards */
body[data-page-theme="simple"] .obra-card,
body[data-page-theme="simple"] .stat-card,
body[data-page-theme="simple"] [class*="-card"] {
  background: #fff;
  border: 1px solid #e0e0e0;
  border-radius: 6px;
  box-shadow: none !important;
}
body[data-page-theme="simple"] .obra-card:hover,
body[data-page-theme="simple"] .stat-card:hover,
body[data-page-theme="simple"] [class*="-card"]:hover {
  border-color: #aaa;
  background: #fafafa;
}

/* painéis / containers */
body[data-page-theme="simple"] [class*="-panel"],
body[data-page-theme="simple"] [class*="-box"],
body[data-page-theme="simple"] [class*="-container"]:not(.shared-search):not(.search-container) {
  border: 1px solid #e0e0e0;
  border-radius: 6px;
  background: #fff;
}

/* tabelas */
body[data-page-theme="simple"] table {
  border-collapse: collapse;
}
body[data-page-theme="simple"] .standard-table th,
body[data-page-theme="simple"] table th {
  background: #f5f5f5;
  font-weight: 500;
  font-size: 11px;
  text-transform: uppercase;
  letter-spacing: 0.04em;
  color: #888;
  border-bottom: 1px solid #e0e0e0;
  padding: 8px 12px;
}
body[data-page-theme="simple"] .standard-table td,
body[data-page-theme="simple"] table td {
  border-bottom: 1px solid #f0f0f0;
  color: #333;
  font-size: 13px;
  padding: 8px 12px;
}
body[data-page-theme="simple"] table tr:hover td {
  background: #fafafa;
}

/* botões primários — flat sem gradiente */
body[data-page-theme="simple"] .btn-primary {
  background: #333;
  color: #fff;
  border: 1px solid #333;
  border-radius: 5px;
  font-weight: 500;
  font-size: 13px;
}
body[data-page-theme="simple"] .btn-primary:hover {
  background: #111;
  border-color: #111;
}

/* botões secundários */
body[data-page-theme="simple"] .btn-secondary {
  background: #fff;
  color: #444;
  border: 1px solid #d0d0d0;
  border-radius: 5px;
  font-weight: 400;
  font-size: 13px;
}
body[data-page-theme="simple"] .btn-secondary:hover {
  background: #f5f5f5;
  border-color: #aaa;
}

/* subnav pills */
body[data-page-theme="simple"] .shared-subnav {
  background: #ebebeb;
  border-radius: 6px;
  gap: 2px;
}
body[data-page-theme="simple"] .shared-subnav-btn {
  font-size: 12px;
  font-weight: 400;
  color: #666;
  border-radius: 4px;
}
body[data-page-theme="simple"] .shared-subnav-btn.active {
  background: #fff;
  color: #222;
  font-weight: 500;
}
body[data-page-theme="simple"] .shared-subnav-btn:hover {
  color: #222;
  background: rgba(255,255,255,0.5);
}

/* inputs */
body[data-page-theme="simple"] input[type="text"],
body[data-page-theme="simple"] input[type="email"],
body[data-page-theme="simple"] input[type="number"],
body[data-page-theme="simple"] input[type="date"],
body[data-page-theme="simple"] select,
body[data-page-theme="simple"] textarea,
body[data-page-theme="simple"] .shared-search input,
body[data-page-theme="simple"] .search-container input {
  background: #fff;
  border: 1px solid #d0d0d0;
  border-radius: 4px;
  font-size: 13px;
  color: #333;
}
body[data-page-theme="simple"] input:focus,
body[data-page-theme="simple"] select:focus,
body[data-page-theme="simple"] textarea:focus,
body[data-page-theme="simple"] .shared-search input:focus {
  border-color: #555;
  outline: none;
  box-shadow: none !important;
}

/* badges / tags de estado */
body[data-page-theme="simple"] [class*="status-"],
body[data-page-theme="simple"] [class*="-badge"],
body[data-page-theme="simple"] [class*="-tag"] {
  background: #ebebeb !important;
  color: #444 !important;
  border: none !important;
  font-size: 11px;
  font-weight: 500;
}

/* scrollbar discreta */
body[data-page-theme="simple"] ::-webkit-scrollbar { width: 4px; height: 4px; }
body[data-page-theme="simple"] ::-webkit-scrollbar-thumb { background: #ccc; border-radius: 4px; }`, "",{"version":3,"sources":["webpack://./src/App.css"],"names":[],"mappings":"AAAA;EACE,SAAS;EACT,UAAU;EACV,sBAAsB;AACxB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,gFAAgF;EAChF,mBAAmB;EACnB,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,yBAAyB;AAC3B;;AAEA,2CAA2C;AAC3C;EACE,kBAAkB;EAClB,gBAAgB;EAChB,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,gBAAgB;EAChB,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,gBAAgB;EAChB,cAAc;AAChB;;AAEA;;;;EAIE,eAAe;EACf,gBAAgB;AAClB;;AAEA,oCAAoC;AACpC;;;;;;;;EAQE,oBAAoB;EACpB,0BAA0B;EAC1B,gBAAgB;EAChB,cAAc;EACd,iBAAiB;EACjB,yBAAyB;EACzB,kBAAkB;EAClB,oBAAoB;AACtB;;AAEA;;;;;;;;EAQE,aAAa;EACb,qBAAqB;EACrB,6CAA6C;AAC/C;;AAEA,WAAW;AACX;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,cAAc;EACd,kBAAkB;AACpB;;AAEA,gCAAgC;AAChC;EACE,oBAAoB;EACpB,eAAe;EACf,gBAAgB;AAClB;;AAEA,mBAAmB;AACnB;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,iBAAiB;EACjB,6DAA6D;EAC7D,YAAY;AACd;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,0CAA0C;EAC1C,uBAAuB;EACvB,kBAAkB;EAClB,kCAAkC;EAClC,mBAAmB;AACrB;;AAEA;EACE;IACE,yBAAyB;EAC3B;AACF;;AAEA,oCAAoC;AACpC;EACE,aAAa;EACb,8BAA8B;EAC9B,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,cAAc;EACd,SAAS;EACT,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,cAAc;EACd,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,SAAS;EACT,mBAAmB;AACrB;;AAEA,kCAAkC;AAClC;EACE,mBAAmB;EACnB,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,eAAe;EACf,oBAAoB;EACpB,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,mBAAmB;EACnB,2BAA2B;EAC3B,+CAA+C;AACjD;;AAEA;EACE,iBAAiB;EACjB,cAAc;EACd,yBAAyB;EACzB,kBAAkB;EAClB,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,eAAe;EACf,oBAAoB;EACpB,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA,wBAAwB;AACxB;EACE,iBAAiB;EACjB,yBAAyB;EACzB,kBAAkB;EAClB,iBAAiB;EACjB,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,WAAW;EACX,gBAAgB;EAChB,yCAAyC;EACzC,oBAAoB;EACpB,mBAAmB;AACrB;;AAEA;EACE,qBAAqB;EACrB,6CAA6C;AAC/C;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,WAAW;EACX,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,iBAAiB;AACnB;;AAEA,4DAA4D;AAC5D;EACE,WAAW;EACX,yBAAyB;EACzB,eAAe;AACjB;;AAEA;EACE,mBAAmB;EACnB,kBAAkB;EAClB,gBAAgB;EAChB,gBAAgB;EAChB,cAAc;EACd,eAAe;EACf,yBAAyB;EACzB,sBAAsB;EACtB,gCAAgC;EAChC,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;EACjB,gCAAgC;EAChC,cAAc;EACd,eAAe;EACf,sBAAsB;AACxB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA,sBAAsB;AACtB;EACE,UAAU;EACV,WAAW;AACb;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;AACrB;;AAEA,gDAAgD;AAChD;EACE,aAAa;EACb,QAAQ;EACR,mBAAmB;EACnB,kBAAkB;EAClB,YAAY;EACZ,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,iBAAiB;EACjB,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,cAAc;EACd,uBAAuB;EACvB,qBAAqB;EACrB,mBAAmB;AACrB;;AAEA,2BAA2B,cAAc,EAAE,iCAAiC,EAAE;AAC9E,4BAA4B,gBAAgB,EAAE,cAAc,EAAE,qCAAqC,EAAE;;AAErG,kCAAkC;AAClC;EACE,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,gBAAgB;EAChB,kBAAkB;EAClB,yBAAyB;EACzB,kBAAkB;EAClB,kBAAkB;EAClB,sBAAsB;EACtB,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,qBAAqB;EACrB,8CAA8C;AAChD;;AAEA;;;yEAGyE;;AAEzE,0DAA0D;AAC1D;EACE,mBAAmB;AACrB;AACA;;EAEE,mBAAmB;AACrB;AACA;EACE,mBAAmB;AACrB;AACA,oBAAoB;AACpB;;;;EAIE,mBAAmB;AACrB;AACA;EACE,mBAAmB;EACnB,4BAA4B;AAC9B;;AAEA,0DAA0D;AAC1D;EACE,mBAAmB;EACnB,cAAc;AAChB;AACA;;;EAGE,mBAAmB;AACrB;AACA;EACE,mBAAmB;EACnB,2CAA2C;EAC3C,cAAc;AAChB;AACA;;;;;;EAME,cAAc;AAChB;AACA;;;;;;;;;EASE,mBAAmB;EACnB,oCAAoC;EACpC,cAAc;AAChB;AACA;EACE,mBAAmB;EACnB,cAAc;EACd,2CAA2C;AAC7C;AACA;;;EAGE,oCAAoC;EACpC,cAAc;AAChB;AACA;EACE,kCAAkC;AACpC;AACA;;;EAGE,mBAAmB;EACnB,oCAAoC;EACpC,cAAc;AAChB;AACA;;EAEE,mBAAmB;EACnB,oCAAoC;EACpC,cAAc;AAChB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,cAAc;AAChB;AACA;EACE,mBAAmB;EACnB,cAAc;AAChB;AACA;EACE,mBAAmB;EACnB,oCAAoC;EACpC,cAAc;AAChB;AACA;EACE,mBAAmB;AACrB;;AAEA,wEAAwE;AACxE;EACE,mBAAmB;EACnB,4CAA4C;EAC5C,gBAAgB;EAChB,WAAW;EACX,eAAe;AACjB;;AAEA,WAAW;AACX;;;EAGE,mBAAmB;AACrB;;AAEA,YAAY;AACZ;EACE,gBAAgB;EAChB,gCAAgC;EAChC,gBAAgB;EAChB,kBAAkB;AACpB;AACA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,WAAW;EACX,uBAAuB;AACzB;AACA;EACE,iBAAiB;EACjB,WAAW;AACb;;AAEA,qBAAqB;AACrB;EACE,iBAAiB;EACjB,gBAAgB;EAChB,WAAW;EACX,uBAAuB;AACzB;AACA;EACE,eAAe;EACf,gBAAgB;EAChB,WAAW;EACX,uBAAuB;AACzB;AACA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,WAAW;AACb;AACA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,WAAW;AACb;;AAEA,0CAA0C;AAC1C;EACE,2BAA2B;EAC3B,4BAA4B;AAC9B;AACA;EACE,0BAA0B;AAC5B;;AAEA,UAAU;AACV;;;EAGE,gBAAgB;EAChB,yBAAyB;EACzB,kBAAkB;EAClB,2BAA2B;AAC7B;AACA;;;EAGE,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA,yBAAyB;AACzB;;;EAGE,yBAAyB;EACzB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA,YAAY;AACZ;EACE,yBAAyB;AAC3B;AACA;;EAEE,mBAAmB;EACnB,gBAAgB;EAChB,eAAe;EACf,yBAAyB;EACzB,sBAAsB;EACtB,WAAW;EACX,gCAAgC;EAChC,iBAAiB;AACnB;AACA;;EAEE,gCAAgC;EAChC,WAAW;EACX,eAAe;EACf,iBAAiB;AACnB;AACA;EACE,mBAAmB;AACrB;;AAEA,0CAA0C;AAC1C;EACE,gBAAgB;EAChB,WAAW;EACX,sBAAsB;EACtB,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;AACjB;AACA;EACE,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA,uBAAuB;AACvB;EACE,gBAAgB;EAChB,WAAW;EACX,yBAAyB;EACzB,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;AACjB;AACA;EACE,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA,iBAAiB;AACjB;EACE,mBAAmB;EACnB,kBAAkB;EAClB,QAAQ;AACV;AACA;EACE,eAAe;EACf,gBAAgB;EAChB,WAAW;EACX,kBAAkB;AACpB;AACA;EACE,gBAAgB;EAChB,WAAW;EACX,gBAAgB;AAClB;AACA;EACE,WAAW;EACX,iCAAiC;AACnC;;AAEA,WAAW;AACX;;;;;;;;EAQE,gBAAgB;EAChB,yBAAyB;EACzB,kBAAkB;EAClB,eAAe;EACf,WAAW;AACb;AACA;;;;EAIE,kBAAkB;EAClB,aAAa;EACb,2BAA2B;AAC7B;;AAEA,4BAA4B;AAC5B;;;EAGE,8BAA8B;EAC9B,sBAAsB;EACtB,uBAAuB;EACvB,eAAe;EACf,gBAAgB;AAClB;;AAEA,uBAAuB;AACvB,qDAAqD,UAAU,EAAE,WAAW,EAAE;AAC9E,2DAA2D,gBAAgB,EAAE,kBAAkB,EAAE","sourcesContent":["* {\r\n  margin: 0;\r\n  padding: 0;\r\n  box-sizing: border-box;\r\n}\r\n\r\nhtml {\r\n  overscroll-behavior: none;\r\n}\r\n\r\nbody {\r\n  font-family: 'Segoe UI', -apple-system, BlinkMacSystemFont, 'Roboto', sans-serif;\r\n  background: #f0f2f5;\r\n  color: #1a1a2e;\r\n  font-size: 14px;\r\n  line-height: 1.5;\r\n  overscroll-behavior: none;\r\n}\r\n\r\n/* Typography System - Uniform Font Sizes */\r\nh1 {\r\n  font-size: 1.85rem;\r\n  font-weight: 600;\r\n  line-height: 1.2;\r\n  color: #1a1a2e;\r\n}\r\n\r\nh2 {\r\n  font-size: 1.25rem;\r\n  font-weight: 600;\r\n  line-height: 1.3;\r\n  color: #2d3748;\r\n  margin-bottom: 12px;\r\n}\r\n\r\nh3 {\r\n  font-size: 1.1rem;\r\n  font-weight: 600;\r\n  line-height: 1.3;\r\n  color: #2d3748;\r\n}\r\n\r\nh4 {\r\n  font-size: 0.95rem;\r\n  font-weight: 600;\r\n  line-height: 1.4;\r\n  color: #4a5568;\r\n}\r\n\r\np,\r\nlabel,\r\nspan,\r\ndiv {\r\n  font-size: 14px;\r\n  line-height: 1.5;\r\n}\r\n\r\n/* Form Controls - Uniform Styling */\r\ninput[type=\"text\"],\r\ninput[type=\"email\"],\r\ninput[type=\"password\"],\r\ninput[type=\"number\"],\r\ninput[type=\"date\"],\r\ninput[type=\"time\"],\r\nselect,\r\ntextarea {\r\n  font-family: inherit;\r\n  font-size: 14px !important;\r\n  line-height: 1.5;\r\n  color: #2d3748;\r\n  padding: 8px 12px;\r\n  border: 1px solid #cbd5e0;\r\n  border-radius: 6px;\r\n  transition: all 0.2s;\r\n}\r\n\r\ninput[type=\"text\"]:focus,\r\ninput[type=\"email\"]:focus,\r\ninput[type=\"password\"]:focus,\r\ninput[type=\"number\"]:focus,\r\ninput[type=\"date\"]:focus,\r\ninput[type=\"time\"]:focus,\r\nselect:focus,\r\ntextarea:focus {\r\n  outline: none;\r\n  border-color: #3182ce;\r\n  box-shadow: 0 0 0 3px rgba(49, 130, 206, 0.1);\r\n}\r\n\r\n/* Labels */\r\nlabel {\r\n  font-size: 13px;\r\n  font-weight: 500;\r\n  color: #4a5568;\r\n  display: block;\r\n  margin-bottom: 6px;\r\n}\r\n\r\n/* Buttons - Uniform Font Size */\r\nbutton {\r\n  font-family: inherit;\r\n  font-size: 14px;\r\n  font-weight: 600;\r\n}\r\n\r\n/* Loading Screen */\r\n.loading-screen {\r\n  display: flex;\r\n  flex-direction: column;\r\n  align-items: center;\r\n  justify-content: center;\r\n  min-height: 100vh;\r\n  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);\r\n  color: white;\r\n}\r\n\r\n.spinner {\r\n  width: 50px;\r\n  height: 50px;\r\n  border: 4px solid rgba(255, 255, 255, 0.3);\r\n  border-top-color: white;\r\n  border-radius: 50%;\r\n  animation: spin 1s linear infinite;\r\n  margin-bottom: 15px;\r\n}\r\n\r\n@keyframes spin {\r\n  to {\r\n    transform: rotate(360deg);\r\n  }\r\n}\r\n\r\n/* Global Standard Layout Elements */\r\n.standard-header {\r\n  display: flex;\r\n  justify-content: space-between;\r\n  align-items: flex-start;\r\n  margin-bottom: 24px;\r\n}\r\n\r\n.standard-header-info h1 {\r\n  font-size: 1.85rem;\r\n  color: #1a1a2e;\r\n  margin: 0;\r\n  display: flex;\r\n  align-items: center;\r\n  gap: 12px;\r\n}\r\n\r\n.standard-header-info p {\r\n  color: #718096;\r\n  margin: 5px 0 0;\r\n  font-size: 0.95rem;\r\n}\r\n\r\n.standard-header-actions {\r\n  display: flex;\r\n  gap: 12px;\r\n  align-items: center;\r\n}\r\n\r\n/* Standard Buttons and Controls */\r\n.btn-primary {\r\n  background: #3182ce;\r\n  color: white;\r\n  border: none;\r\n  padding: 10px 20px;\r\n  border-radius: 8px;\r\n  font-weight: 600;\r\n  font-size: 14px;\r\n  cursor: pointer;\r\n  transition: all 0.2s;\r\n  display: flex;\r\n  align-items: center;\r\n  gap: 8px;\r\n}\r\n\r\n.btn-primary:hover {\r\n  background: #2b6cb0;\r\n  transform: translateY(-1px);\r\n  box-shadow: 0 4px 12px rgba(49, 130, 206, 0.25);\r\n}\r\n\r\n.btn-secondary {\r\n  background: white;\r\n  color: #4a5568;\r\n  border: 1px solid #e2e8f0;\r\n  padding: 10px 20px;\r\n  border-radius: 8px;\r\n  font-weight: 600;\r\n  font-size: 14px;\r\n  cursor: pointer;\r\n  transition: all 0.2s;\r\n  display: flex;\r\n  align-items: center;\r\n  gap: 8px;\r\n}\r\n\r\n.btn-secondary:hover {\r\n  background: #f7fafc;\r\n  border-color: #cbd5e0;\r\n}\r\n\r\n/* Standard Search Box */\r\n.search-container {\r\n  background: white;\r\n  border: 1px solid #e2e8f0;\r\n  border-radius: 8px;\r\n  padding: 9px 16px;\r\n  display: flex;\r\n  align-items: center;\r\n  gap: 10px;\r\n  width: 100%;\r\n  max-width: 450px;\r\n  box-shadow: 0 1px 2px rgba(0, 0, 0, 0.05);\r\n  transition: all 0.2s;\r\n  margin-bottom: 20px;\r\n}\r\n\r\n.search-container:focus-within {\r\n  border-color: #3182ce;\r\n  box-shadow: 0 0 0 3px rgba(49, 130, 206, 0.1);\r\n}\r\n\r\n.search-container input {\r\n  border: none;\r\n  outline: none;\r\n  width: 100%;\r\n  font-size: 0.92rem;\r\n  color: #2d3748;\r\n}\r\n\r\n.search-icon {\r\n  color: #a0aec0;\r\n  font-size: 1.1rem;\r\n}\r\n\r\n/* Standard Table — estilo uniforme para toda a plataforma */\r\n.standard-table {\r\n  width: 100%;\r\n  border-collapse: collapse;\r\n  font-size: 13px;\r\n}\r\n\r\n.standard-table th {\r\n  background: #f8fafc;\r\n  padding: 10px 14px;\r\n  text-align: left;\r\n  font-weight: 600;\r\n  color: #64748b;\r\n  font-size: 11px;\r\n  text-transform: uppercase;\r\n  letter-spacing: 0.05em;\r\n  border-bottom: 2px solid #edf2f7;\r\n  white-space: nowrap;\r\n}\r\n\r\n.standard-table td {\r\n  padding: 9px 14px;\r\n  border-bottom: 1px solid #f3f4f6;\r\n  color: #2d3748;\r\n  font-size: 13px;\r\n  vertical-align: middle;\r\n}\r\n\r\n.standard-table tr:last-child td {\r\n  border-bottom: none;\r\n}\r\n\r\n.standard-table tr:hover td {\r\n  background: #f8fafc;\r\n}\r\n\r\n/* Scrollbar styling */\r\n::-webkit-scrollbar {\r\n  width: 8px;\r\n  height: 8px;\r\n}\r\n\r\n::-webkit-scrollbar-track {\r\n  background: #f1f1f1;\r\n}\r\n\r\n::-webkit-scrollbar-thumb {\r\n  background: #c1c1c1;\r\n  border-radius: 4px;\r\n}\r\n\r\n::-webkit-scrollbar-thumb:hover {\r\n  background: #a1a1a1;\r\n}\r\n\r\n/* ---- Shared Sub-navigation (pill tabs) ---- */\r\n.shared-subnav {\r\n  display: flex;\r\n  gap: 4px;\r\n  background: #e2e8f0;\r\n  border-radius: 8px;\r\n  padding: 3px;\r\n  margin-bottom: 14px;\r\n  width: fit-content;\r\n}\r\n\r\n.shared-subnav-btn {\r\n  padding: 8px 20px;\r\n  border: none;\r\n  border-radius: 6px;\r\n  font-size: 13px;\r\n  font-weight: 600;\r\n  cursor: pointer;\r\n  color: #64748b;\r\n  background: transparent;\r\n  transition: all 0.15s;\r\n  white-space: nowrap;\r\n}\r\n\r\n.shared-subnav-btn:hover { color: #1e293b; background: rgba(255,255,255,0.6); }\r\n.shared-subnav-btn.active { background: #fff; color: #3182ce; box-shadow: 0 1px 4px rgba(0,0,0,0.1); }\r\n\r\n/* ---- Shared Search Input ---- */\r\n.shared-search {\r\n  margin-bottom: 20px;\r\n}\r\n\r\n.shared-search input {\r\n  width: 100%;\r\n  max-width: 450px;\r\n  padding: 10px 14px;\r\n  border: 1px solid #e2e8f0;\r\n  border-radius: 8px;\r\n  font-size: 0.95rem;\r\n  box-sizing: border-box;\r\n  background: white;\r\n}\r\n\r\n.shared-search input:focus {\r\n  outline: none;\r\n  border-color: #3182ce;\r\n  box-shadow: 0 0 0 2px rgba(49, 130, 206, 0.15);\r\n}\r\n\r\n/* ====================================================================\r\n   PAGE THEMES — aplicados via data-page-theme no <body>\r\n   \"default\" não tem regras = padrão intocado\r\n   ==================================================================== */\r\n\r\n/* ---------- LIGHT — fundo branco mais limpo ---------- */\r\nbody[data-page-theme=\"light\"] {\r\n  background: #ffffff;\r\n}\r\nbody[data-page-theme=\"light\"] .page-content,\r\nbody[data-page-theme=\"light\"] .app-layout {\r\n  background: #ffffff;\r\n}\r\nbody[data-page-theme=\"light\"] .main-content {\r\n  background: #ffffff;\r\n}\r\n/* cards / tabelas */\r\nbody[data-page-theme=\"light\"] .card,\r\nbody[data-page-theme=\"light\"] .table-card,\r\nbody[data-page-theme=\"light\"] .obras-grid > *,\r\nbody[data-page-theme=\"light\"] .standard-table th {\r\n  background: #f8fafc;\r\n}\r\nbody[data-page-theme=\"light\"] .top-bar {\r\n  background: #ffffff;\r\n  border-bottom-color: #e2e8f0;\r\n}\r\n\r\n/* ---------- DARK — fundo escuro nas páginas ---------- */\r\nbody[data-page-theme=\"dark\"] {\r\n  background: #0f172a;\r\n  color: #e2e8f0;\r\n}\r\nbody[data-page-theme=\"dark\"] .page-content,\r\nbody[data-page-theme=\"dark\"] .app-layout,\r\nbody[data-page-theme=\"dark\"] .main-content {\r\n  background: #0f172a;\r\n}\r\nbody[data-page-theme=\"dark\"] .top-bar {\r\n  background: #1e293b;\r\n  border-bottom-color: rgba(255,255,255,0.08);\r\n  color: #e2e8f0;\r\n}\r\nbody[data-page-theme=\"dark\"] .top-bar-title h1,\r\nbody[data-page-theme=\"dark\"] .top-bar-title p,\r\nbody[data-page-theme=\"dark\"] h1,\r\nbody[data-page-theme=\"dark\"] h2,\r\nbody[data-page-theme=\"dark\"] h3,\r\nbody[data-page-theme=\"dark\"] h4 {\r\n  color: #e2e8f0;\r\n}\r\nbody[data-page-theme=\"dark\"] .card,\r\nbody[data-page-theme=\"dark\"] .table-card,\r\nbody[data-page-theme=\"dark\"] .obras-card,\r\nbody[data-page-theme=\"dark\"] .obra-card,\r\nbody[data-page-theme=\"dark\"] [class*=\"-card\"],\r\nbody[data-page-theme=\"dark\"] [class*=\"-table\"],\r\nbody[data-page-theme=\"dark\"] [class*=\"-panel\"],\r\nbody[data-page-theme=\"dark\"] [class*=\"-box\"],\r\nbody[data-page-theme=\"dark\"] [class*=\"-container\"]:not(.shared-search):not(.search-container) {\r\n  background: #1e293b;\r\n  border-color: rgba(255,255,255,0.08);\r\n  color: #e2e8f0;\r\n}\r\nbody[data-page-theme=\"dark\"] .standard-table th {\r\n  background: #0f172a;\r\n  color: #94a3b8;\r\n  border-bottom-color: rgba(255,255,255,0.08);\r\n}\r\nbody[data-page-theme=\"dark\"] .standard-table td,\r\nbody[data-page-theme=\"dark\"] table td,\r\nbody[data-page-theme=\"dark\"] table th {\r\n  border-color: rgba(255,255,255,0.06);\r\n  color: #e2e8f0;\r\n}\r\nbody[data-page-theme=\"dark\"] table tr:hover td {\r\n  background: rgba(255,255,255,0.04);\r\n}\r\nbody[data-page-theme=\"dark\"] input,\r\nbody[data-page-theme=\"dark\"] select,\r\nbody[data-page-theme=\"dark\"] textarea {\r\n  background: #0f172a;\r\n  border-color: rgba(255,255,255,0.12);\r\n  color: #e2e8f0;\r\n}\r\nbody[data-page-theme=\"dark\"] .shared-search input,\r\nbody[data-page-theme=\"dark\"] .search-container input {\r\n  background: #1e293b;\r\n  border-color: rgba(255,255,255,0.12);\r\n  color: #e2e8f0;\r\n}\r\nbody[data-page-theme=\"dark\"] .shared-subnav {\r\n  background: #1e293b;\r\n}\r\nbody[data-page-theme=\"dark\"] .shared-subnav-btn {\r\n  color: #94a3b8;\r\n}\r\nbody[data-page-theme=\"dark\"] .shared-subnav-btn.active {\r\n  background: #0f172a;\r\n  color: #60a5fa;\r\n}\r\nbody[data-page-theme=\"dark\"] .btn-secondary {\r\n  background: #1e293b;\r\n  border-color: rgba(255,255,255,0.12);\r\n  color: #e2e8f0;\r\n}\r\nbody[data-page-theme=\"dark\"] .btn-secondary:hover {\r\n  background: #334155;\r\n}\r\n\r\n/* ---------- SIMPLE — tipografia leve, flat, monocromático ---------- */\r\nbody[data-page-theme=\"simple\"] {\r\n  background: #f5f5f5;\r\n  font-family: 'Inter', 'Segoe UI', sans-serif;\r\n  font-weight: 400;\r\n  color: #333;\r\n  font-size: 13px;\r\n}\r\n\r\n/* layout */\r\nbody[data-page-theme=\"simple\"] .page-content,\r\nbody[data-page-theme=\"simple\"] .app-layout,\r\nbody[data-page-theme=\"simple\"] .main-content {\r\n  background: #f5f5f5;\r\n}\r\n\r\n/* top bar */\r\nbody[data-page-theme=\"simple\"] .top-bar {\r\n  background: #fff;\r\n  border-bottom: 1px solid #e0e0e0;\r\n  box-shadow: none;\r\n  padding: 12px 24px;\r\n}\r\nbody[data-page-theme=\"simple\"] .top-bar-title h1 {\r\n  font-size: 1.1rem;\r\n  font-weight: 500;\r\n  color: #222;\r\n  letter-spacing: -0.01em;\r\n}\r\nbody[data-page-theme=\"simple\"] .top-bar-title p {\r\n  font-size: 0.8rem;\r\n  color: #888;\r\n}\r\n\r\n/* tipografia geral */\r\nbody[data-page-theme=\"simple\"] h1 {\r\n  font-size: 1.3rem;\r\n  font-weight: 500;\r\n  color: #222;\r\n  letter-spacing: -0.02em;\r\n}\r\nbody[data-page-theme=\"simple\"] h2 {\r\n  font-size: 1rem;\r\n  font-weight: 500;\r\n  color: #333;\r\n  letter-spacing: -0.01em;\r\n}\r\nbody[data-page-theme=\"simple\"] h3 {\r\n  font-size: 0.9rem;\r\n  font-weight: 500;\r\n  color: #444;\r\n}\r\nbody[data-page-theme=\"simple\"] h4 {\r\n  font-size: 0.82rem;\r\n  font-weight: 500;\r\n  color: #555;\r\n}\r\n\r\n/* remover todas as sombras e transforms */\r\nbody[data-page-theme=\"simple\"] * {\r\n  box-shadow: none !important;\r\n  text-shadow: none !important;\r\n}\r\nbody[data-page-theme=\"simple\"] *:hover {\r\n  transform: none !important;\r\n}\r\n\r\n/* cards */\r\nbody[data-page-theme=\"simple\"] .obra-card,\r\nbody[data-page-theme=\"simple\"] .stat-card,\r\nbody[data-page-theme=\"simple\"] [class*=\"-card\"] {\r\n  background: #fff;\r\n  border: 1px solid #e0e0e0;\r\n  border-radius: 6px;\r\n  box-shadow: none !important;\r\n}\r\nbody[data-page-theme=\"simple\"] .obra-card:hover,\r\nbody[data-page-theme=\"simple\"] .stat-card:hover,\r\nbody[data-page-theme=\"simple\"] [class*=\"-card\"]:hover {\r\n  border-color: #aaa;\r\n  background: #fafafa;\r\n}\r\n\r\n/* painéis / containers */\r\nbody[data-page-theme=\"simple\"] [class*=\"-panel\"],\r\nbody[data-page-theme=\"simple\"] [class*=\"-box\"],\r\nbody[data-page-theme=\"simple\"] [class*=\"-container\"]:not(.shared-search):not(.search-container) {\r\n  border: 1px solid #e0e0e0;\r\n  border-radius: 6px;\r\n  background: #fff;\r\n}\r\n\r\n/* tabelas */\r\nbody[data-page-theme=\"simple\"] table {\r\n  border-collapse: collapse;\r\n}\r\nbody[data-page-theme=\"simple\"] .standard-table th,\r\nbody[data-page-theme=\"simple\"] table th {\r\n  background: #f5f5f5;\r\n  font-weight: 500;\r\n  font-size: 11px;\r\n  text-transform: uppercase;\r\n  letter-spacing: 0.04em;\r\n  color: #888;\r\n  border-bottom: 1px solid #e0e0e0;\r\n  padding: 8px 12px;\r\n}\r\nbody[data-page-theme=\"simple\"] .standard-table td,\r\nbody[data-page-theme=\"simple\"] table td {\r\n  border-bottom: 1px solid #f0f0f0;\r\n  color: #333;\r\n  font-size: 13px;\r\n  padding: 8px 12px;\r\n}\r\nbody[data-page-theme=\"simple\"] table tr:hover td {\r\n  background: #fafafa;\r\n}\r\n\r\n/* botões primários — flat sem gradiente */\r\nbody[data-page-theme=\"simple\"] .btn-primary {\r\n  background: #333;\r\n  color: #fff;\r\n  border: 1px solid #333;\r\n  border-radius: 5px;\r\n  font-weight: 500;\r\n  font-size: 13px;\r\n}\r\nbody[data-page-theme=\"simple\"] .btn-primary:hover {\r\n  background: #111;\r\n  border-color: #111;\r\n}\r\n\r\n/* botões secundários */\r\nbody[data-page-theme=\"simple\"] .btn-secondary {\r\n  background: #fff;\r\n  color: #444;\r\n  border: 1px solid #d0d0d0;\r\n  border-radius: 5px;\r\n  font-weight: 400;\r\n  font-size: 13px;\r\n}\r\nbody[data-page-theme=\"simple\"] .btn-secondary:hover {\r\n  background: #f5f5f5;\r\n  border-color: #aaa;\r\n}\r\n\r\n/* subnav pills */\r\nbody[data-page-theme=\"simple\"] .shared-subnav {\r\n  background: #ebebeb;\r\n  border-radius: 6px;\r\n  gap: 2px;\r\n}\r\nbody[data-page-theme=\"simple\"] .shared-subnav-btn {\r\n  font-size: 12px;\r\n  font-weight: 400;\r\n  color: #666;\r\n  border-radius: 4px;\r\n}\r\nbody[data-page-theme=\"simple\"] .shared-subnav-btn.active {\r\n  background: #fff;\r\n  color: #222;\r\n  font-weight: 500;\r\n}\r\nbody[data-page-theme=\"simple\"] .shared-subnav-btn:hover {\r\n  color: #222;\r\n  background: rgba(255,255,255,0.5);\r\n}\r\n\r\n/* inputs */\r\nbody[data-page-theme=\"simple\"] input[type=\"text\"],\r\nbody[data-page-theme=\"simple\"] input[type=\"email\"],\r\nbody[data-page-theme=\"simple\"] input[type=\"number\"],\r\nbody[data-page-theme=\"simple\"] input[type=\"date\"],\r\nbody[data-page-theme=\"simple\"] select,\r\nbody[data-page-theme=\"simple\"] textarea,\r\nbody[data-page-theme=\"simple\"] .shared-search input,\r\nbody[data-page-theme=\"simple\"] .search-container input {\r\n  background: #fff;\r\n  border: 1px solid #d0d0d0;\r\n  border-radius: 4px;\r\n  font-size: 13px;\r\n  color: #333;\r\n}\r\nbody[data-page-theme=\"simple\"] input:focus,\r\nbody[data-page-theme=\"simple\"] select:focus,\r\nbody[data-page-theme=\"simple\"] textarea:focus,\r\nbody[data-page-theme=\"simple\"] .shared-search input:focus {\r\n  border-color: #555;\r\n  outline: none;\r\n  box-shadow: none !important;\r\n}\r\n\r\n/* badges / tags de estado */\r\nbody[data-page-theme=\"simple\"] [class*=\"status-\"],\r\nbody[data-page-theme=\"simple\"] [class*=\"-badge\"],\r\nbody[data-page-theme=\"simple\"] [class*=\"-tag\"] {\r\n  background: #ebebeb !important;\r\n  color: #444 !important;\r\n  border: none !important;\r\n  font-size: 11px;\r\n  font-weight: 500;\r\n}\r\n\r\n/* scrollbar discreta */\r\nbody[data-page-theme=\"simple\"] ::-webkit-scrollbar { width: 4px; height: 4px; }\r\nbody[data-page-theme=\"simple\"] ::-webkit-scrollbar-thumb { background: #ccc; border-radius: 4px; }"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
